import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { MobileMenuContext } from '../contexts/MobileMenuContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faClock, faImage, faMap, faMoneyBills, faEnvelope } from '@fortawesome/free-solid-svg-icons';

const MainMobileNav = () => {
    const[mobileMenuContext, setMobileMenuContext] = useContext(MobileMenuContext);

    const isLargerThan730 = useMediaQuery({
        query: '(min-width: 730px)'
    });

    const handleClose = () => {
        setMobileMenuContext({
            type: 'HIDE_MENU'
        });
    };

    return(
        <>
            {
                !isLargerThan730 &&
                <Offcanvas show={mobileMenuContext.showMenu} onHide={handleClose}>
                    <Offcanvas.Body>
                        <ul id="main-nav-mobile">
                            <li>
                                <Link to="/" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faHome} />
                                    <span>Accueil</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/horaires" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faClock} />
                                    <span>Horaires</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/Photos" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faImage} />
                                    <span>Photos</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/carte" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faMap} />    
                                    <span>Carte</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/tarifs" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faMoneyBills} />    
                                    <span>Tarifs</span>
                                </Link>
                            </li>
                            <li>
                                <Link to="/contact" onClick={handleClose}>
                                    <FontAwesomeIcon icon={faEnvelope} />    
                                    <span>Contact</span>
                                </Link>
                            </li>
                        </ul>
                    </Offcanvas.Body>
                </Offcanvas>
            }
        </>
    );
};

export default MainMobileNav;
